import { render } from "./setupPermission.vue?vue&type=template&id=a3cc712c"
import script from "./setupPermission.vue?vue&type=script&lang=js"
export * from "./setupPermission.vue?vue&type=script&lang=js"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/branch/staff/setupPermission.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a3cc712c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a3cc712c', __exports__)) {
    console.log('reload')
    api.reload('a3cc712c', __exports__)
  }
  
  module.hot.accept("./setupPermission.vue?vue&type=template&id=a3cc712c", () => {
    console.log('re-render')
    api.rerender('a3cc712c', render)
  })

}


export default __exports__